import { useEffect, useRef, useState } from "react";

interface Props {
  title: string;
}

type Status = "idle" | "loading" | "notice";

export default function PlayerDemo({ title }: Props) {
  const [status, setStatus] = useState<Status>("idle");
  const timer = useRef<number | undefined>(undefined);

  useEffect(() => {
    return () => {
      if (timer.current) window.clearTimeout(timer.current);
    };
  }, []);

  const handlePlay = () => {
    if (status === "loading") return;
    setStatus("loading");
    timer.current = window.setTimeout(() => setStatus("notice"), 1200);
  };

  return (
    <div className="relative w-full overflow-hidden rounded-lg bg-primary-950">
      <div className="aspect-video w-full">
        <div className="relative flex h-full w-full flex-col items-center justify-center px-5 text-center">
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-primary-900/70 via-primary-950 to-primary-950"></div>

          {status === "notice" ? (
            <div className="relative flex flex-col items-center">
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-accent-500/15">
                <i className="ri-information-line text-2xl text-accent-400" aria-hidden="true"></i>
              </span>
              <p className="mt-4 text-sm font-medium text-background-50">当前为前端演示播放区</p>
              <p className="mt-2 max-w-[520px] text-xs leading-6 text-background-300">
                《{title}》暂未接入真实播放源，本站不提供视频播放与下载能力。本区域仅用于展示播放页面的交互与排版效果。
              </p>
              <button
                type="button"
                onClick={() => setStatus("idle")}
                className="mt-5 cursor-pointer whitespace-nowrap rounded-md border border-background-50/25 px-4 py-2 text-xs text-background-100 transition-colors hover:border-accent-400 hover:text-accent-300"
              >
                返回演示封面
              </button>
            </div>
          ) : (
            <div className="relative flex flex-col items-center">
              <button
                type="button"
                onClick={handlePlay}
                aria-label={`播放${title}演示`}
                className="flex h-16 w-16 cursor-pointer items-center justify-center rounded-full bg-accent-500 transition-transform hover:scale-105 md:h-20 md:w-20"
              >
                {status === "loading" ? (
                  <i className="ri-loader-4-line animate-spin text-2xl text-primary-950 md:text-3xl" aria-hidden="true"></i>
                ) : (
                  <i className="ri-play-fill text-3xl text-primary-950 md:text-4xl" aria-hidden="true"></i>
                )}
              </button>
              <p className="mt-4 text-sm text-background-100">
                {status === "loading" ? "正在加载演示画面…" : `《${title}》中文字幕 · 高清演示`}
              </p>
              <p className="mt-1.5 text-[11px] text-background-400">播放功能为演示占位，点击后查看说明</p>
            </div>
          )}
        </div>
      </div>

      <div className="flex flex-wrap items-center justify-between gap-2 border-t border-primary-800 px-3 py-2.5 md:px-4">
        <p className="flex items-center gap-1.5 text-[11px] text-background-400">
          <i className="ri-error-warning-line text-sm text-accent-400" aria-hidden="true"></i>
          演示模式：无真实片源
        </p>
        <p className="text-[11px] text-background-500">中文字幕 · 高清画质示意 · 不支持下载</p>
      </div>
    </div>
  );
}